export enum EToastType {
  DEFAULT = 'default',
  PROGRESS = 'progress',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}
